import { Alert, AlertTitle, Snackbar } from "@mui/material";
import { useCallback, useMemo } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { uiActions } from "../../features/ui/ui.slice";
import { useUiState } from "../../features/ui/useUiState";
import { CountdownMessage } from "../CountdownMessage";

const noop = () => null;

const ALERT_DEFAULT_AUTO_HIDE_TIMEOUT = 5000;

export const GlobalAlert = () => {
  const dispatch = useDispatch();
  const { uiAlertMessage } = useUiState();
  const t = useIntl();
  const { severity, message, title, errorCode, waitUntil } = uiAlertMessage;

  const handleClose = useCallback(
    () => dispatch(uiActions.setAlertMessage({ severity: undefined })),
    [dispatch],
  );

  const isErrCode = useMemo(
    () => errorCode && !!t.messages[`errorMessages.${errorCode}`],
    [errorCode, t.messages],
  );

  const showAlert = useMemo(
    () => !!title || !!message || isErrCode || !!waitUntil,
    [isErrCode, message, title, waitUntil],
  );

  if (!showAlert || !severity) return null;

  const timer =
    severity === "error" ? ALERT_DEFAULT_AUTO_HIDE_TIMEOUT : undefined;

  return (
    <Snackbar
      open
      ClickAwayListenerProps={{ onClickAway: noop }}
      autoHideDuration={timer}
      anchorOrigin={{ horizontal: "center", vertical: "top" }}
      onClose={handleClose}
    >
      <Alert variant="global" severity={severity} onClose={handleClose}>
        {title && <AlertTitle>{title}</AlertTitle>}
        {!isErrCode && waitUntil && message && (
          <CountdownMessage
            message={message}
            waitUntil={waitUntil}
            onCountdownEnd={handleClose}
          />
        )}
        {!isErrCode && !waitUntil && message}
        {isErrCode && <FormattedMessage id={`errorMessages.${errorCode}`} />}
      </Alert>
    </Snackbar>
  );
};
